import { r as requiredActionProviderRepresentation } from '../../../../common/requiredActionProviderRepresentation-f7bb9634.js';
import '../../../../common/_commonjsHelpers-8a10f9bf.js';



var RequiredActionAlias = requiredActionProviderRepresentation.RequiredActionAlias;
export { RequiredActionAlias };
